export default {
    fund: [{
            "title": "某基金在2015年11月1日单位净值为1.1元，2015年12月31日单位净值为1.02元，其中在2015年8月30日该基金每份额派发红利0.2元，该基金在2015年8月29日（除息前一天）的单位净值为1.21元，则该基金在2015年全年的加权收益率为（　　）。",
            "question": "A．11.1%\nB．-11%\nC．-7.27%\nD．21.1%",
            "answer": "A",
            "explain": "根据公式加权收益率R=（NAV1/NAV0+NAV2/(NAV1-D)-1）×100%，其中NAV0为初始份额净值，NAV1为分红前一日的份额净值，NAV2为最终份额净值，D为份额分红。带入公式得出R=（1.21/1.1×1.02/(1.21-0.2)-1）×100%=11.1%。"
        },
        {
            "title": "基金所投资的债券发生信用风险事件对基金产生的影响不包括（　　）。",
            "question": "A．相关债券流动性丧失，很难变现\nB．相关基金经理需补偿基金资产的损失\nC．估值急剧下跌，基金净值受损\nD．集中赎回基金，带来流动性风险",
            "answer": "B",
            "explain": "信用风险来源于贷款的信贷方、债券发行人以及回购交易和衍生产品的交易对手违约的可能性。例如，基金所投资债券的发行人不能支付到期本息，债券评价下调引起价格下跌，回购交易对手方不履行债券义务等。信用风险事件对持有相关债券的基金和基金公司带来的影响有：（1）相关债券估值急剧下跌，基金净值受损；（2）相关债券流动性丧失，很难变现；（3）投资者集中赎回基金，带来流动性风险；（4）基金公司自有资金受到损失，遭受监管处罚。"
        },
        {
            "title": "假设某附息的固定利率债券的起息日为2009年6月6日，债券面值100元，每半年支付一次利息。2019年6月6日，该债券的投资者可就债券收到本金和利息共计102.25元，则该债券的期限为（　　）年，票面利率为（　　）。",
            "question": "A．10；2.25%\nB．9；2.25%\nC．10；4.5%\nD．9；4.5%",
            "answer": "C",
            "explain": "通过题目可以得到，最后一期时间是2019年6月6日，起息日为2009年6月6日，共计10年，所以是10年期债券；最后一期还本付息共102.25元，本金100元，利息2.25元，因为是每半年付息，每次付息均相等=2.25元=面值*票面利率*1/2=100元*票面利率*1/2，所以得到票面利率=4.5%。"
        },
        {
            "title": "关于算术平均收益率和几何平均收益率，以下表述错误的是（　　）。",
            "question": "A．算术平均收益率计算方法是期收益率的总和除以期\nB．几何平均收益率运用了复利的思想\nC．几何平均收益率忽略了货币的时间价值\nD．两者之间的差距会随收益率波动加剧而增大",
            "answer": "C",
            "explain": "算术平均收益率即计算各期收益率的算术平均值。与算术平均收益率不同，几何平均收益率运用了复利的思想，即考虑了货币的时间价值。一般来说，算术平均收益率要大于几何平均收益率，两者之差随收益率波动加剧而增大。"
        },
        {
            "title": "债券收益率变动对债券价格变动所产生的二阶效应可被称为（　　）。",
            "question": "A．收益率的凹性\nB．债券的久期\nC．收益率的波动性\nD．债券的凸性",
            "answer": "D",
            "explain": "凸性是指在某一到期收益率下，到期收益率发生变动而引起的价格变动幅度的变动程度。凸性是对债券价格曲线弯曲程度的一种度量。凸性的出现是为了弥补久期本身也会随着利率的变化而变化的不足。因为在利率变化比较大的情况下久期就不能完全描述债券价格对利率变动的敏感性。凸性越大，债券价格曲线弯曲程度越大，用修正久期度量债券的利率风险所产生的误差越大。久期描述了价格-收益率曲线的斜率，凸性描述了曲线的弯曲程度。凸性是债券价格对收益率的二阶导数。对债券久期利率敏感性的测量。"
        },
        {
            "title": "关于自上而下的股票投资组合构建策略，以下表述错误的是（　　）。",
            "question": "A．可以通过积极的风格调整，例如转换价值股和成长股的比例，追求风格收益\nB．可以通过研究和预测决定经济形势的核心变量，来决定大类资产配置\nC．可以利用技术面分析深入研究个股的投资价值，挑选出业绩突出的股票获得收益\nD．可以进行积极的板块轮换，从而获得板块的差额收益",
            "answer": "C",
            "explain": "本题考查基本面分析。“自上而下”的层级分析法（三步股价法，宏观-行业-个股）是比较适用基本面分析法的，不适用于技术分析法。这种“自上而下”分析法首先从宏观的经营环境出发，主要考虑国内外的经济环境及其影响因素，确定外部经济环境对公司所处经营行业的影响；然后，分析行业类型和竞争程度，对公司所在行业位置进行确定，最后，利用权益证券估值模型对公司进行综合评价，从而确定公司的合理市场价值。"
        }, {
            "title": "下列关于均值方差法应用到两个风险资产的投资组合中，说法错误的是（　　）。",
            "question": "A．投资组合的预期收益率以及方差会随着投资比例变化\nB．可行投资组合集在方差-预期收益率平面图中表示为抛物线及右侧区域\nC．除与两个风险资产相对应的两个点外，其他点都是由两种资产混合而成的投资组合\nD．抛物线上方的点所代表的投资组合是无法通过组合两个风险资产而得到的",
            "answer": "B",
            "explain": "两个风险资产的投资组合可行域为一条直线、折线或者向左弯曲的曲线，不是区域。线以外的点所代表的投资组合是无法通过组合两个风险资产而得到的，属于无效组合。除与两个风险资产相对应的两个点外，其他点都是由两种资产混合而成的投资组合，线上的不同位置对应的投资比例不同，随即收益率和方差不同。"
        },
        {
            "title": "某投资者通过借入所在证券公司资金购买有价证券的交易方式为（　　）。",
            "question": "A．期货交易\nB．卖空交易\nC．买空交易\nD．现货交易",
            "answer": "C",
            "explain": "买空交易也叫融资，即投资者借入资金购买证券。卖空交易也叫融券，即投资者借入证券卖出，下跌后再买入证券归还证券公司。现货交易是即时或在较短的时间内完成交收的一种交易方式。期货交易是在现货交易基础上衍生出的，在交易所内上市的标准化合约交易。"
        },
        {
            "title": "以下有关交易佣金的说法错误的是（　　）。",
            "question": "A．一般而言，采用网上交易电话等交易方式可以获得比现场交易更低的佣金率\nB．证券公司可以给大资金客户较低的佣金率\nC．证券公司可以根据客户忠诚度调整交易佣金\nD．一般而言，交易不活跃的投资者享有的佣金率较低",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "对于长期投资者来说，收益目标应更关注的是（　　）。",
            "question": "A．预期收益率\nB．实际收益率\nC．名义收益率\nD．平均收益率",
            "answer": "B",
            "explain": "对于长期投资者而言，应该关注的是实际收益率。因为实际收益率能够反映资产的实际购买能力的增长率，而名义收益率仅仅反映了资产名义数值的增长率。"
        },
        {
            "title": "以下金融衍生工具中，通常由交易所统一制定，在交易所进行交易的是（　　）。",
            "questions": "I．远期合约<br>II．期货合约<br>III．期权合约<br>IV．互换合约",
            "question": "A．I、IV\nB．III、IV\nC．I、II\nD．II、III",
            "answer": "D",
            "explain": "衍生品合约可以在交易所和场外交易。期货合约只在交易所交易。期权合约大部分在交易所交易。远期合约和互换合约通常在场外交易，采用非标准形式进行，以满足交易各方需求，具有较高的灵活性，这也使得谈判较为复杂，交易成本较高。"
        },
        {
            "title": "某公募基金的投资范围包括股票、债券和银行存款等，关于该基金投资活动产生的税收，以下表述错误的是（　　）。",
            "question": "A．从证券市场中取得的收入，暂不征收所得税\nB．买卖股票、债券取得的差价收入免征增值税\nC．投资银行存款取得的存款利息不征收增值税\nD．卖出股票不征收印花税",
            "answer": "D",
            "explain": "股票买入的时候不收取印花税，而卖出的时候要收取印花税。证券投资基金在证券市场上取得了所有收益，均免征企业所得税。银行存款利息和金融商品转让收入免征收增值税。"
        },
        {
            "title": "根据我国的实践，在基金投资决策中，负责制定投资组合具体方案的是基金管理公司的（　　）。",
            "question": "A．投资部\nB．交易部\nC．投资决策委员会\nD．研究部",
            "answer": "A",
            "explain": "不同的基金公司的投资管理部门设置有所差别，但基本包括以下几个部分，即投资决策委员会、投资部、研究部、交易部。其中，投资部负责根据投资决策委员会制定的投资原则和计划制定投资组合的具体方案，研究部负责下达投资指令。"
        }, {
            "title": "关于股票的账面价值和清算价值，以下表述错误的是（　　）。",
            "question": "A．股票的清算价值是根据资产实际出售额计算的\nB．在公司清算时，大多数公司股票的清算价值实际上高于其账面价值\nC．理论上股票的清算价值应与账面价值一致，但实际上并非如此\nD．股票的清算价值是公司清算时每一股份所代表的实际价值",
            "answer": "B",
            "explain": "股票的清算价值是公司清算时每一股份所代表的实际价值。理论上，股票的清算价值应与账面价值一致，但实际上并非如此。只有当清算时的资产实际出售额与财务报表上反映的账面价值一致时，每一股的清算价值才会和账面价值一致。但在公司清算时，其资产往往只能压低价格出售，再加上必要的清算费用，故大多数公司股票的清算价值低于其账面价值。"
        },
        {
            "title": "在半强有效证券市场中，证券价格所反映的信息不包括（　　）。",
            "question": "A．证券的交易量、公司并购公告\nB．证券的交易量、红利发放公告\nC．证券的盈利预测、公司并购公告\nD．未公开发布的公司重组信息",
            "answer": "D",
            "explain": "半强有效市场是指证券价格不仅已经反映了历史价格信息，而且反映了当前所有与公司证券有关的公开有效信息，例如盈利预测、红利发放、股票分析、公司并购等各种公告信息。“未公开发布的公司重组信息”属于内部消息，不能在半强有效市场中反映出。"
        },
        {
            "title": "关于沪港通及深港通的重要意义，以下表述错误的是（　　）。",
            "question": "A．推动人民币跨境资本流动\nB．构建良好的人民币外流机制\nC．刺激人民币资产需求，加大人民币交投量\nD．完善国内资本市场",
            "answer": "B",
            "explain": "沪港通的开通是我国资本市场对外开放的重要内容，有利于加强两地资本市场联系，推动资本市场双向开放，具有多方面的积极意义：一是有利于通过一项全新的合作机制增强我国资本市场的综合实力，完善国内资本市场。沪港通业务可以深化交流合作，扩大两地投资者的投资渠道，提升市场竞争力。二是有利于巩固上海和香港两个金融中心的地位。沪港通有助于提高上海及香港两地市场对国际投资者的吸引力。"
        },
        {
            "title": "一般而言，以下哪只基金的跟踪误差通常比较低（　　）。",
            "question": "A．XX中证医药主题指数增强基金\nB．XX灵活配置基金\nC．XX核心成长基金\nD．XX上证50指数基金",
            "answer": "D",
            "explain": "跟踪误差是根据历史收益率的差值数据来描述基金与跟踪标的指数之间的密切程度，同时揭示基金收益波动特征。跟踪误差越小，基金经理的管理能力越强。影响指数基金跟踪误差的因素主要包括基金仓位的影响、标的指数成份股的变化、增强型指数化组合、计算尾差及基金资产的费用支出等。总的来说，提高跟踪标的指数的精度，降低跟踪是指数投资最为核心的技术，也是指数基金这一投资工具能够用之于投资者大类资产配置的前提。上证50指数历史的波动性比较小，所以它的跟踪误差较小。"
        },
        {
            "title": "衍生工具的价值与基础产品或基础变量紧密联系、规则变动，这是衍生工具基本特征之一的（　　）。",
            "question": "A．跨期性\nB．杠杆性\nC．不确定性\nD．联动性",
            "answer": "D",
            "explain": "联动性指衍生工具的价值与合约标的资产价值紧密相关，衍生资产价格与标的资产的价格具有联动性。"
        },
        {
            "title": "投资经理因预期市场利率将会下降1%而对债券投资组合进行调整，最恰当的策略是调整（　　）。",
            "question": "A．组合久期\nB．流动性\nC．信用结构\nD．杠杆率",
            "answer": "A",
            "explain": "如果债券基金经理能够较好地确定持有期，那么就能够找到所有的久期等于持有期的债券，并选择凸性最高的那种债券。利率变化是影响债券价格的主要因素之一。久期和凸性是衡量债券价格随利率变化特性的两个重要指标。"
        }, {
            "title": "2015年度，某公司的营业利润40亿元，营业外收入17亿元，营业外支出5亿元，则利润总额为（　　）。",
            "question": "A．18亿元\nB．52亿元\nC．23亿元\nD．35亿元",
            "answer": "B",
            "explain": "利润总额=营业利润+补贴收入+营业外收入-营业外支出=主营业务收入-主营业务成本-主营业务税金及附加-期间费用(销售费用、管理费用、财务费用)+其他业务收入-其他业务成本+投资损益+补贴收入+营业外收入-营业外支出，由于题中只给出营业利润、营业外收入和营业外支出，所以就可以简化计算，即利润总额=营业利润+营业外收入-营业外支出=40亿+17亿-5亿=52亿。"
        },
        {
            "title": "某基金管理人计划发行一只开放式基金产品，在确定基金估值相关条款时，以下表述正确的是（　　）。",
            "questions": "I．根据监管要求，开放式基金必须每个自然日估值<br>II．该基金管理人可根据投资品种特性，选择有别于其他基金产品的估值原则和方法<br>III．该管理人应建立定期复核和审阅估值程序和技术的机制<br>IV．在投资品涉及不适合公开的商业机密时，管理人可不披露基金的估值程序和估值技术",
            "question": "A．I、II、III\nB．II、IV\nC．I、II、III、IV\nD．III",
            "answer": "D",
            "explain": "目前，我国的开放式基金于每个交易日估值，并于次日公告基金份额净值。估值方法的一致性是指基金在进行资产估值时均应采取同样的估值方法，遵守同样的估值规则，基金管理人对投资品种进行估值时应保持程序和技术的一致性。估值方法的公开性是指基金管理人应履行与基金估值相关的披露义务，应当在半年度和年度报告中披露估值程序、估值技术及重大变化、假设、输入值、对基金资产净值及当期损益的影响等对基金估值有重大影响的信息。"
        },
        {
            "title": "某股票的前收盘价为10元，配股价格为8元，股份变动比例为100%，那么除权参考价为（　　）。",
            "question": "A．2元\nB．9元\nC．10元\nD．8元",
            "answer": "B",
            "explain": "除权(息)参考价=(前收盘价+现金红利+配股价格*股份变动比例)/(1+股份变动比例)，则有：(10+8*100%)/(1+100%)=18/2=9元。"
        },
        {
            "title": "关于基金业绩归因，以下表述错误的是（　　）。",
            "question": "A．基金运作的各项费用对绝对收益有影响\nB．混合型基金超额收益由资产配置决定\nC．相对收益归因也适用于对指数基金的评价\nD．绝对收益归因和相对收益归因可以同时运用",
            "answer": "B",
            "explain": "投资管理的三大根本能力为风险管理能力、证券选择能力和时机选择能力。投资组合管理首要的是风险管理，要在控制风险的基础上创造稳定、可持续的超额收益，超额收益的来源主要通过证券选择和时机选择。证券选择能力为基金通过选择价值被低估的证券产生额外收益的能力；时机选择能力为基金根据对市场走势的判断，通过调整基金资产/行业/证券配置，以增加或降低对市场的敏感度进而跑赢基金基准、创造超额收益的能力。"
        },
        {
            "title": "关于货币市场基金，以下表述正确的是（　　）。",
            "questions": "I．货币市场基金可以投资剩余存续期小于397天但剩余期限超过397天的浮动利率债券<br>II．浮动利率债券可参考回购利率作为基准利率<br>III．货币市场基金的杠杆风险通常比债券基金低<br>IV．通常采用摊余成本法进行估值核算",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II\nD．III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "对于交易所上市交易的流通受限股票，按照以下公式确定估值日该股票的价值：FV=S*(1-LoMD)，其中LoMD=P/S，该公式中，P是估值日看跌期权的价值，该看跌期权的类型为（　　）。",
            "question": "A．亚式期权\nB．欧式期权\nC．百慕大期权\nD．美式期权",
            "answer": "A",
            "explain": "亚式期权的收益依附于标准的资产有效期至少一段时间内的平均价格。按照计算机基础价格的不同，亚式期权可分为平均价期权和平均执行价格期权。证券投资基金持有的流通受限股票在估值日按平均价格亚式期权模型确定估值日看跌期权的价值。"
        }, {
            "title": "反转收益率曲线的期限结构特征是（　　）。",
            "question": "A．短期债券收益率较低，而长期债券收益率较高\nB．长短期债券收益率基本相等\nC．短期债券收益率较高，而长期债券收益率较低\nD．期限相对较短的债券，利率与期限呈正向关系，而期限相对较长的债券，利率与期限呈反向关系",
            "answer": "C",
            "explain": "收益率曲线有四种类型：第一类是上升收益率曲线，也叫正向收益率曲线，其期限结构特征是短期债券收益率低，而长期债券收益率较高；第二类是反转收益率曲线，其期限结构是短期债券收益率高，而长期债券收益率低；第三类是水平收益率曲线，其期限结构是长短期债券的收益率基本相等；第四类是拱形收益率曲线，其期限结构是，期限相对较短的债券，利率与期限成正向相关，而期限相对较长的债券，利率与期限呈反向关系。"
        },
        {
            "title": "某投资者将其100万元资金分别投向A、B、C股票，投资金额分别为30万元、20万元、50万元，A、B、C股票的期望收益率分别为10%、10%、20%，则该投资者持有的股票组合期望收益率为（　　）。",
            "question": "A．10%\nB．15%\nC．20%\nD．13.33%",
            "answer": "B",
            "explain": "投资组合的期望收益率=∑(权重x对应的收益率)=30%x10%+20%x10%+50%x20%=15%，故本题选B。"
        },
        {
            "title": "关于业绩比较基准，以下表述错误的是（　　）。",
            "question": "A．业绩比较基准的选取与投资范围没有关系\nB．业绩比较基准的作用在于事后业绩评估时可以比较基金的收益与比较基准之间的差异\nC．基金相对收益，就是基金相对于一定基准的收益\nD．业绩比较基准的作用在于事先确定好业绩比较基准可以为基金经理投资管理提供指引",
            "answer": "A",
            "explain": "业绩比较基准的选取与投资范围有关系，业绩比较基准的选择一般取决于基金的投资范围。"
        },
        {
            "title": "已知某公司年销售收入是1000万元，其年均应收账款为50万元，那么该公司收回一次账面上全部应收账款平均需要的天数是（　　）。",
            "question": "A．7\nB．3\nC．18.3\nD．20",
            "answer": "C",
            "explain": "应收账款周转率=销售收入/年均应收账款，周转天数=365/应收账款周转率，由题可知应收账款周转率=1000/50=20，周转天数=365/20=18.25，约为：18.3天。"
        },
        {
            "title": "下列选项中将未来某时点资金的价值折算为现在时点的价值称为（　　）。",
            "question": "A．现值\nB．贴现率\nC．兑现\nD．贴现",
            "answer": "D",
            "explain": "将未来某时点资金的价值折算为现在时点的价值称为贴现。"
        },
        {
            "title": "关于市场有效性的标准及三个层次，以下表述正确的是（　　）。",
            "questions": "I．根据时间维度，把信息划分为历史信息、当前公开可得信息及内部信息<br>II．三个层级的有效市场包括弱有效市场、半强有效市场及强有效市场<br>III．如果证券市场是半强有效的，市场参与者就可以从公开信息中获取超额利润，意味着基本面分析有效<br>IV．在弱有效证券市场，任何预测未来证券价格走势而对以往价格、交易量等历史信息进行的技术分析都是徒劳的",
            "question": "A．II、III、IV\nB．I、III、IV\nC．I、II、IV\nD．I、II、III",
            "answer": "C",
            "explain": ""
        }, {
            "title": "某债券的面值为100元，如果当前的市场价格接近100元，期限越长时，以下描述正确的是（　　）。",
            "question": "A．当期收益越接近到期收益率\nB．当期收益率越偏离到期收益率\nC．当期收益率的变动总是预示着到期收益率的反向变动\nD．当期收益率与到期收益率的关系无法判断",
            "answer": "A",
            "explain": "债券当期收益率与到期收益率两者之间关系的如下：(1)债券市场价格越接近债券面值，期限越长，则其当期收益率就越接近到期收益率。(2)债券市场价格越偏离债券面值，期限越短，则当期收益率就越偏离到期收益率。但是不论当期收益率与到期收益率近似程度如何，当期收益率的变动总是预示着到期收益率的同向变动。"
        },
        {
            "title": "下列风险调整后的收益指标中，不以CAPM模型为基础的是（　　）。",
            "question": "A．詹森比率\nB．信息比率\nC．特雷诺比率\nD．麦普比率",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于全球投资业绩标准(GIPS)，以下表述正确的是（　　）。",
            "questions": "I．可以提高业绩报告的透明度<br>II．让不同投资管理机构的投资业绩具有可比性<br>III．为了让机构展示业绩良好的组合<br>IV．确保在一致、可靠、公平且可比的基础上报告投资业绩数据",
            "question": "A．I、II、III、IV\nB．I、III、IV\nC．I、II、IV\nD．II、III、IV",
            "answer": "C",
            "explain": "遵循GIPS可以提高业绩报告的透明度，确保在一致、可靠、公平且可比的基础上报告投资业绩数据，让不同投资管理机构的投资业绩具有可比性。"
        },
        {
            "title": "关于个人投资者的常见特征，以下表述正确的有（　　）。",
            "questions": "I．投资需求受个人所处生命周期的不同阶段和个人境况的影响，呈现较大的差异<br>II．可投资的资金量较小<br>III．风险承受能力较强<br>IV．投资相关的知识和经验较少，专业投资能力不足<br>V．不太需要借助基金销售服务机构进行投资",
            "question": "A．I、II、IV\nB．I、II、IV、V\nC．I、II、III、IV、V\nD．I、II、III、V",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于投资组合管理的基本流程，以下表述正确的是（　　）。",
            "questions": "I．投资组合管理的目标是在获得一定收益水平的同时承担最低风险，或在投资者可接受的风险水平内获得最大收益<br>II．CFA协会将投资者管理过程定义为一个动态反馈的循环过程，包括规划、执行和反馈三个基础步骤<br>III．规划主要侧重于确定决策所需要的各种输入信息，包括客户资料和资本市场的数据<br>IV．反馈是对投资预期、投资目标和投资组合等方面变化的适应过程",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II、III、IV\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "下列哪项不是期货合约的要素（　　）。",
            "question": "A．行权价\nB．最小变动单位\nC．期货品种\nD．交割等级",
            "answer": "A",
            "explain": "期货合约的要素有交易品种、交易单位、报价单位、最小变动单位、交割日期、交割等级等。"
        }, {
            "title": "以下属于证券投资基金场内证券交易结算原则的有（　　）。",
            "questions": "I．法人结算原则<br>II．共同对手方制度<br>III．货银对付原则<br>IV．分级结算原则",
            "question": "A．II、III、IV\nB．I、II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "B",
            "explain": "场内证券交易结算原则包括：法人结算原则、共同对手方制度和货银对付原则以及分级结算原则。"
        },
        {
            "title": "关于利率互换和股票收益互换，以下表述正确的是（　　）。",
            "question": "A．与利率互换不同，股票收益互换经常作为一种投机工具，而不是风险管理的工具\nB．固定利率与股票收益的互换本质上属于利率互换的一种模式\nC．某投资者看好一只股票，计划1个月后增持，但希望将价格锁定到现在的水平，可以与证券公司订立股票收益互换协议\nD．证券公司与投资者订立股票收益互换交易后，即使进行对冲，风险也将暴露在较高水平",
            "answer": "C",
            "explain": "利率互换和股票收益互换都是风险管理工具，利率互换指互换合约双方同意在约定期限内按不同的利息计算方式分期向对方支付由币种相同的名义本金额所确定的利息。利率互换有两种形式：①息票互换，即固定利率对浮动利率的互换；②基础互换，即双方以不同参照利率互换利息支付。股票收益互换中，交易一方或双方支付的金额与特定股票、指数等权益类标的证券的表现挂钩，某投资者看好某只股票，计划1个月后增持，但希望将价格锁定到现在的水平，可以与证券公司订立股票收益互换协议。"
        },
        {
            "title": "目前我国定期发布各类债券收益率曲线的机构包括（　　）。",
            "questions": "I．上海清算所<br>II．中证指数有限公司<br>III．上海有色金属交易所<br>IV．中央国债登记结算有限责任公司",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II、IV\nD．I、II、III",
            "answer": "C",
            "explain": "目前，中央国债登记结算有限责任公司、中证指数有限公司、上海清算所等机构会定期发布我国各类债券的收益率曲线。"
        },
        {
            "title": "某货币市场基金管理人为防范债券回购风险可以采取的措施不包括（　　）。",
            "question": "A．质押品按公允价值应足额，并持续监测质押品的风险状况与价值变动\nB．在进行逆回购交易时，严格规范可接受质押品的资质\nC．在进行正回购交易时，优选高等级债进行质押以达到高杠杆比例\nD．建立健全逆回购交易质押品管理制度",
            "answer": "C",
            "explain": "为防范债券回购风险可以采取的措施有：建立健全逆回购交易质押品管理制度(D正确)，根据质押品资质审慎确定质押率水平；质押品按公允价值应足额，并持续监测质押品的风险状况与价值变动(A正确)；在进行逆回购交易时，严格规范可接受质押品的资质(B正确)，故本题选C。"
        },
        {
            "title": "某境外金融机构今年起担任某QDII基金（简称A基金）的投资顾问，同时该投资顾问自去年起还担任着另一家海外对冲基金（简称B基金）的投资顾问。如果该投资顾问在T日上午为A基金买入某只股票，在T日下午为B基金买入相同的股票，则该2个账户的交易价格应首先遵循（　　）。",
            "question": "A．按下单时间优先，上午的买入价格作为A基金的结算价，下午的买入价格作为B基金的结算价\nB．交易量优先，将较好的价格给买入量较大的基金，将较差的价格给买入量较小的基金\nC．使用全天买入的均价作为两个账户的结算价\nD．按担任投资顾问时间优先，将较好的价格给B基金，将较差的价格给A基金",
            "answer": "A",
            "explain": "一家机构担任不同基金的投顾需要保持业务独立性以及保证公平性。按照下单顺序进行成交。"
        },
        {
            "title": "买断式回购首期资金结算额的计算公式为（　　）。",
            "question": "A．(首期交易净价+到期结算日应计利息)*(回购证券数量/100)\nB．(首期交易净价+首期结算日应计利息)*(回购债券数量/100)\nC．首期资金结算额*(1+回购利率*回购债券数量/100)\nD．(到期交易净价+到期结算日应计利息)*(回购债券数量/100)",
            "answer": "B",
            "explain": "买断式回购是指一方（正回购方）在将回购债券出售给另一方（逆回购方），逆回购方在首期结算日向正回购方支付首期资金结算额的同时，交易双方约定在将来某一日期（即到期结算日）由正回购方以约定价格（即到期资金结算额）从逆回购方购回回购债券的交易。买断式回购：首期资金结算额=(首期交易净价+首期结算日应计利息)*(回购债券数量/100)；到期资金结算额=(到期交易净价+到期结算日应计利息)*(回购债券数量/100)。"
        }, {
            "title": "关于零息债券，以下表述错误的是（　　）。",
            "question": "A．投资收益全部源于资本利得\nB．可以计算到期收益率\nC．期间不支付利息\nD．可以折价、平价或溢价发行",
            "answer": "D",
            "explain": "本题考查零息债券。零息债券和固定利率债券一样有一定的偿还期限，但在期间不支付利息，而在到期日一次性支付利息和本金，一般其值为债券面值。因此，零息债券以低于面值的价格发行，即为折价发行。到期日支付的面值和发行时价格的差额即为投资者的收益，即属于资本利得。"
        },
        {
            "title": "投资者A购买了某股票指数的期货合约，投资者B购买了相关指数的看涨期权，以下表述正确的是（　　）。",
            "question": "A．伴随股票指数上涨，投资者A一定可以盈利\nB．即使股票指数下跌，投资者A的损失也是可以控制的\nC．即使股票指数下跌，投资者B的损失是可以控制的\nD．伴随着股票指数上涨，投资者B一定可以盈利",
            "answer": "C",
            "explain": "看涨期权的买方损失有限，收益无限。所以“对于投资者B来说，损失有限，可以控制”。对于单纯期货买方来说，没有任何对冲工具，如果遇到标的物大幅下跌是没办法控制自身风险的，所以“即使股票指数下跌，投资者A的损失是可以控制的”说法不准确。"
        },
        {
            "title": "资产A与资产B的收益率相关系数为-0.3，则这两个资产所构成的投资组合的标准差-预期收益率关系图是（　　）。",
            "question": "A．向左上方弯曲的曲线\nB．向右下方弯曲的曲线\nC．斜率为1的直线\nD．斜率为-1的直线",
            "answer": "A",
            "explain": "如果资产A和资产B的收益率和相关系数在-1和1之间，那么两个资产的投资组合将呈一条向左上方弯曲的曲线，曲线上的每一个点表示资产权重不同的投资组合。相关系数越小，组合的曲线越往左边弯曲，组合风险越小（即在相同收益率的情况下，风险更小），组合的效用越高。当相关系数为1时，两个证券组合是一条直线；当相关系数是-1时，就是完全负相关，是一条折线，并且与纵轴有交点，可以完全规避组合的波动风险。"
        },
        {
            "title": "关于不动产投资的含义和特点，以下表述错误的是（　　）。",
            "question": "A．直接的不动产投资流动性较差，通常表现为产权交易时间长、费用高，若要快速转售，投资者往往要承担较大折价损失\nB．直接的不动产投资金额大且难以拆分，这意味着该项投资可能会占据到一个投资组合的很大比例\nC．不动产投资具有异质性，这使得不动产估值具有一定的难度\nD．不动产投资是指投资者直接出资购买商业房地产，用于出租获取租金收益或等待增值之后出售获取增值收益",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于期货合约，以下表述错误的是（　　）。",
            "question": "A．金融期货合约的交割大多采用现金结算\nB．期货合约是非标准化合约\nC．投机者是期货市场的重要组成部分\nD．时市制度对保证期货合约的履行非常重要",
            "answer": "B",
            "explain": "期货合约是指交易双方签署的在未来某个确定时间按确定价格买入或卖出某项合约的标的资产的合约。相对于远期合约而言，期货合约是标准化合约。"
        },
        {
            "title": "关于受偿等级不同的债券，下列说法错误的是（　　）。",
            "question": "A．次级债券在清偿时仅有少量补偿甚至没有补偿\nB．有保证债券有时也被称为信用债券\nC．优先无保证债券在受偿等级排序上要优先于优先次级债券\nD．专利和品牌也可以作为有保证债券的保证物",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于股份公司的资本，以下说法错误的是（　　）。",
            "question": "A．公司债券利率一般高于同期国债利率\nB．普通股股东可以获得公司的分红\nC．优先股和普通股都代表对公司的所有权\nD．公司债券需要还本付息，不属于公司资本",
            "answer": "D",
            "explain": "公司可以通过发行权益证券或债权来筹集外部资本，支持公司运营。最基本的资本结构是债权资本和权益资本的比例。公司债券属于公司资本的一类。"
        }, {
            "title": "关于资产配置的层次，以下表述正确的是（　　）。",
            "question": "A．运用战术资产配置的前提条件是基金管理人能够准确地预测市场变化，发现单个证券的机会，并能够有效实施动态资产的配置方案\nB．战术资产配置是在较长投资期限内以追求长期回报为目标的资产配置\nC．战略资产配置的有效性存在争议，战略资产配置对战术资产配置的偏离往往被限制在一定范围之内\nD．战术资产配置是根据投资者的风险承受能力，对资产做出事前的、整体性的、与投资者需求匹配的规划",
            "answer": "A",
            "explain": "战略资产配置是在较长投资期限内以追求长期回报为目标的资产配置，故第二项表述错误，应为“战略资产配置”；战术资产配置的有效性存在争议，战术资产配置对战略资产配置的偏离往往被限制在一定范围之内，故第三项说法错误，不是“战略资产配置”，而是“战术资产配置”；战略资产配置根据投资者的风险承受能力，对资产做出事前的、整体性的、与投资者需求匹配的规划，故第四项表达错误，应为“战略资产配置”。"
        },
        {
            "title": "关于沪深300指数，以下表述错误的是（　　）。",
            "question": "A．沪深300指数在上海和深圳证券市场中选取300只A股和B股作为样本\nB．目前国内已有多个基金跟踪沪深300指数\nC．沪深300指数包含沪深300的价格指数和全收益指数\nD．沪深300指数是由中证指数有限公司编制",
            "answer": "A",
            "explain": "沪深300指数在上海和深圳证券市场中选取300只A股作为样本，以2004年12月31日为基期，基点为1000点，其计算以调整股本为权重，采用派氏加权综合价格指数公式进行计算。中证指数有限公司同时计算并发布沪深300的价格指数和全收益指数，其中价格指数实时发布，全收益指数每日收盘后在中证指数公司网站和上海证券交易所网站上发布。"
        },
        {
            "title": "主动比重为100%则意味着（　　）。",
            "question": "A．该投资组合实质上是一个指数基金\nB．该投资组合与基准完全相同\nC．该投资组合的表现一定与基准差别较大\nD．该投资组合与基准完全不同",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于单利和复利，以下表述错误的是（　　）。",
            "question": "A．复利考虑了本金的时间价值\nB．复利考虑了利息的时间价值\nC．单利考虑了本金的时间价值\nD．单利考虑了利息的时间价值",
            "answer": "D",
            "explain": "单利只考虑本金的时间价值，不考虑利息的时间价值。复利既考虑本金的时间价值也考虑利息的时间价值。因此，“单利考虑了利息的时间价值”错误。"
        },
        {
            "title": "关于互换合约，以下表述正确的是（　　）。",
            "question": "A．货币互换通常是指两种货币资金的本金和利息交换\nB．现实生活中较为常见的是货币互换合约和信用违约互换\nC．利率互换通常伴随本金\nD．利率互换是指同种货币资金不同种类利率之间的交换合约",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "小明购买了某上市公司票面价值为50元，股息率为8%的优先股共1000股，则小明每年收到该公司支付的优先股息一共（　　）元。",
            "question": "A．4000\nB．800\nC．6250\nD．5000",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某公司2017年的销售利润率比2016年下降5%，总资产周转率提高10%，假定其他条件净利润和总资产等与2016年相同，那么该公司2017年的净资产收益率比2016年提高（　　）。",
            "question": "A．10.5%\nB．5.5%\nC．4.5%\nD．10%",
            "answer": "C",
            "explain": ""
        }, {
            "title": "某投资组合的主动比重为（　　）时，意味着该投资组合与基准完全相同。",
            "question": "A．0.2\nB．1\nC．0\nD．0.5",
            "answer": "C",
            "explain": "主动比重(AS)是指投资组合持仓与基准不同的部分。主动比重为0，意味着该投资组合实质上是一个指数基金，主动比重为大于0则意味着该投资组合与基准不同。"
        },
        {
            "title": "公募基金A的基金管理人是甲基金管理公司，基金托管人是乙商业银行，则该基金会计核算的责任主体是（　　）。",
            "questions": "I．公募基金A<br>II．甲基金管理公司<br>III．乙商业银行",
            "question": "A．I、II、III\nB．II、III\nC．I、III\nD．I、II",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于贝塔系数，以下表述错误的是（　　）。",
            "question": "A．通过将25%的投资预算投入到国库券，其余投入到市场资产组合，可以构建β值为0.75的资产组合\nB．当β=0.5时，市场组合收益率上涨1%，资产收益率上涨0.5%\nC．β系数衡量证券所面临的系统性风险，当β=0时，证券的预期收益率为0\nD．当β=2时，市场组合收益率上涨1.5%，资产收益率上涨3%",
            "answer": "C",
            "explain": "β系数衡量证券所面临的系统性风险，当β=0时，预期收益不为0，为无风险收益率。"
        },
        {
            "title": "某企业净资产为1000万元，当年的销售收入为600万元，销售成本为400万元，预计未来一年利润为500万元，市销率为5，用市销率计算该公司市值是（　　）万元。",
            "question": "A．5000\nB．2000\nC．2500\nD．4000",
            "answer": "D",
            "explain": "市销率也称价格营收比，是股票市价与销售收入的比率，该指标反映单位销售收入所反映的股价水平，根据盖干得到：市销率=5=股票市价/销售收入(800万)，股票市价=5*800万=4000万。"
        },
        {
            "title": "关于财务报表，以下表述错误的是（　　）。",
            "question": "A．资产负债表记录企业某一时点的资产、负债和所有者权益的状况\nB．财务报表按照财务会计准则定期编制，用以显示企业实际的财务状况和经营业绩优劣\nC．利润表反映一定时期内企业的总体经营成果，揭示企业获取利润的能力和经营趋势，又被称为“第一会计报表”\nD．所有者权益主要由股本、资本公积、盈余公积和未分配利润构成",
            "answer": "C",
            "explain": "本题考查资产负债表的作用。"
        },
        {
            "title": "为准确、及时进行基金估值和份额净值计价，基金管理人应（　　）。",
            "question": "A．建立基金估值工作机制，并申请基金托管行批准\nB．制定基金估值和份额净值计价的业务管理制度\nC．对没有活跃市场或在活跃市场不存在相同特征的品种提出估值指引\nD．定期对估值指引进行评估和修订",
            "answer": "B",
            "explain": "本题考查基金管理人的职责。(1)基金管理人：为准确、及时进行基金估值和份额净值计价，基金管理人应制定基金估值和份额净值计价的业务管理制度（B选项正确），明确基金估值的程序和技术；建立估值委员会，健全估值决策体系；使用可靠的估值业务系统；确保估值人员熟悉各类投资品种的估值原则及具体估值程序；完善相关风险监测、控制和报告机制；建立定期复核和审阅机制，以确保相关程序和技术不存在重大缺陷。基金管理人应充分理解相关估值原则及技术，与托管人充分协商，谨慎确定公允价值。即使基金管理人选择服务机构进行估值，也不能免除"
        },
        {
            "title": "某基金总资产60亿元，总负债10亿元，发行在外的基金份数为40亿份，该基金的基金份额净值为（　　）元。",
            "question": "A．1.25\nB．1.2\nC．1.75\nD．1.5",
            "answer": "A",
            "explain": "基金资产净值=基金资产-基金负债=60-10=50亿元，基金份额净值=基金资产净值/基金总份额=50亿/40亿=1.25元。"
        }, {
            "title": "关于债券回购风险，以下表述正确的是（　　）。",
            "questions": "I．若交易发起人抵押出债券、借入资金，则该交易称为债券正回购<br>II．正回购方目的在于获得利息收入<br>III．正回购比例低的债券基金杠杆比例低<br>IV．债券回购是一种收益稳定、无信用风险的投资品种",
            "question": "A．I、III\nB．II、III、IV\nC．II、IV\nD．I、II、III",
            "answer": "A",
            "explain": "正回购方抵押债券给逆回购方，融入资金。逆回购方获得利息收入；债券回购存在信用风险。"
        },
        {
            "title": "以下不属于基金公司交易员职责的是（　　）。",
            "question": "A．在接收到交易指令后会根据自身对市场的判断来选择是否立刻完成交易\nB．严格遵守公司的公平交易制度\nC．构建投资组合\nD．按照公平、公正的原则执行交易",
            "answer": "C",
            "explain": "交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易（A正确）。交易员在执行交易的过程中必须严格按照公平公正的原则执行（D正确），在执行公平交易时需严格遵守公司的公平交易制度（B正确）。故本题选C。"
        },
        {
            "title": "关于债券的发行主体，以下表述错误的是（　　）。",
            "question": "A．证券公司短期融资券也可以归类为金融债券\nB．我国中央政府可以代理地方政府发行地方政府债\nC．特种金融债券是指经中国人民银行批准，由部分金融机构发行的，所筹集的资金专门用于偿还不规范证券回购债务的有价证券\nD．无论在哪个国家，非股份制企业都是不允许发行债券的",
            "answer": "D",
            "explain": "按发行主体分类，债券可分为政府债券、金融债券、公司债券等。"
        },
        {
            "title": "风险投资是私募股权投资的形式之一，以下关于风险投资的表述错误的是（　　）。",
            "question": "A．风险投资的主要收益来源是所投资企业的利润分配\nB．与成长权益战略相比，风险投资具有更高风险\nC．风险投资在投资初期没有投资回报\nD．风险投资主要投资于初创型公司",
            "answer": "A",
            "explain": "风险投资的收益不是来自企业自身的分红，而是来自企业成熟壮大之后的股权转让。"
        },
        {
            "title": "构建一个包含A、B两类资产的投资组合，关于该组合中资产收益的相关性，以下表述正确的是（　　）。",
            "questions": "I．投资组合中两类资产相关系数为0时的组合风险大于相关系数为1时的组合风险<br>II．投资组合中两类资产相关系数是-1时，可以构建一个等效于无风险资产的组合<br>III．投资组合中两类资产相关系数是1时，组合的预期收益高于相关系数是0的组合预期收益<br>IV．投资组合中两类资产相关系数是1时,组合的预期收益高于相关系数是-1的组合的预期收益",
            "question": "A．I\nB．I、III、IV\nC．II\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于商业票据，以下表述正确的是（　　）。",
            "questions": "I．为满足流动资金的需求所发行的期限为2天至270天的，可流通转让的债务工具<br>II．商业票据已成为一种方便公司获取短期信贷的债务工具，广义的商业票据指在金融市场上流通的商业汇票和商业本票，狭义的商业票据仅指商业本票<br>III．特点主要有三点：面额较大、利率较低、流动性好<br>IV．采取贴现发行方式，资信良好的发行人可采取直接发行",
            "question": "A．I、II、IV\nB．I、II、III\nC．II、III、IV\nD．I、III、IV",
            "answer": "A",
            "explain": ""
        }, {
            "title": "关于提高企业盈利能力的做法，以下表述正确的是（　　）。",
            "question": "A．提高企业的净利润，从而提高企业的资产收益率\nB．提高销售收入，从而提高企业的总资产周转率\nC．提高企业的总资产，从而提高企业的杠杆比率\nD．降低企业的负债，从而提高企业的资产负债率",
            "answer": "A",
            "explain": "选项中，只有“提高企业的净利润，从而提高企业的资产收益率”中的资产收益率属于盈利能力比率。盈利能力比率：销售利润率(ROS)、资产收益率(ROA)、净资产收益率(ROE)；流动性比率：流动比率、速动比率；"
        },
        {
            "title": "某债券基金的投资人赎回了净值1000万元的基金份额，并支付了0.5%的赎回费，根据该基金合同，该笔赎回费的50%计入基金资产，假定该笔赎回费未发生手续费，则以下表述正确的是（　　）。",
            "question": "A．基金获得利息收入2.5万元\nB．基金获得非经常收入2.5万元\nC．基金获得其他收入2.5万元\nD．基金获得投资收益2.5万元",
            "answer": "C",
            "explain": "其他收入是指除上述收入以外的其他各项收入，包括赎回费扣除基本手续费后的余额、手续费返还、ETF替代损益，以及基金管理人等机构为弥补基金财产损失而付给基金的赔偿款项等。这些收入项目一般根据发生的实际金额确认。题干中说明是投资者进行赎回操作后，在不考虑手续费的前提下，该笔收入属于其他收入，收入额为1000万*0.5%*50%=2.5万。另外基金利息收入、投资收益和其他收入共同组成基金利润（基金收入）。"
        },
        {
            "title": "以下不属于债券估值方法的是（　　）。",
            "question": "A．自由现金流估值法\nB．固定利率债券估值法\nC．统一公债估值法\nD．零息债券估值法",
            "answer": "A",
            "explain": "债券的估值方法包括：零息债券估值法、固定利率债券估值法、统一公债估值法。"
        },
        {
            "title": "某基金的投资目标是透过挖掘存在于各相关证券子市场以及不同金融工具间的投资机会，灵活配置资产，并充分基金资产的使用效率，在实现基金资产保值基础上获取更高的投资收益，则该基金属于（　　）。",
            "question": "A．指数投资基金\nB．主动投资基金\nC．被动投资基金\nD．股票型基金",
            "answer": "B",
            "explain": "与被动投资相比，在一个并非完全有效的市场上，主动投资策略更能体现其价值，从而给投资者带来较高的回报。这种收益主要来自两种情况：1．主动投资者比其他大多数投资者拥有更好的信息，即市场“共识”以外的信息；2．主动投资者在面对相同信息时，能够更高效的使用信息并通过积极交易产生回报。"
        },
        {
            "title": "小张和小王投资一只场外货币基金，小张在上周五申购，这周四赎回，小王在上周四申购这周五赎回，假设期间除周末节假日外，不涉及其他法定节假日，则两人享受该货币基金分红收益的天数相差（　　）天。",
            "question": "A．6\nB．2\nC．5\nD．4",
            "answer": "A",
            "explain": "《货币市场基金监督管理办法》第15条规定：当日申购的基金份额自下一个交易日起享有基金的分配权益，当日赎回的基金份额自下一个交易日起不享有基金的分配权益，但中国证监会认定的特殊货币市场基金品种除外。货币市场基金每周五进行分配时，将同时分配周六和周日的利润；每周一至周四进行分配时，则仅对当日利润进行分配，所以小张于周五申购或转换转入的基金份额不享有周五和周六、周日的利息。"
        },
        {
            "title": "资本市场线采用（　　）来衡量风险。",
            "question": "A．标准差\nB．斜率\nC．相关系数\nD．β值",
            "answer": "A",
            "explain": "资本市场线实际上指出了有效投资组合风险与预期收益率之间的关系，提供了衡量有效投资组合风险的方法。有效投资组合即是分布于资本市场线上的点，代表了有效前沿。特别是它指出了以标准差来表示的有效投资组合的风险，其与回报率之间是一种线性关系，因此以标准差来度量风险是更为合适的。"
        }, {
            "title": "关于预期损失(ES)指标，以下表述错误的是（　　）。",
            "question": "A．预期损失也被称为条件风险价值度\nB．能衡量极端情况发生时损失的平均值\nC．不满足次可加性\nD．是指在给定时间区间和置信区间内，投资组合损失的期望值",
            "answer": "C",
            "explain": "预期损失，是指在给定时间区间和置信区间内，投资组合损失的期望值。预期损失也被称为条件风险价值尺度或条件尾部期望或尾部损失。预期损失由于其在尾部风险度量、次可加性等方面的优势，越来越受到金融行业与监管机构的重视，ES是极端情况发生时损失的平均值。"
        },
        {
            "title": "已知甲投资者为货币基金A最大的份额持有人，持有货币基金A占总份额的75%，根据规定，货币基金A投资组合的平均剩余期限不得超过N天，投资组合中现金、国债、中央银行票据、政策性金融债券以及5个交易日内到期的其他金融工具占基金资产净值合计不得低于M，N和M分别为（　　）。",
            "question": "A．N90, M20%\nB．N90, M30%\nC．N60, M30%\nD．N60, M20%",
            "answer": "C",
            "explain": "当货币市场基金前10名份额持有人的持有份额合计超过基金总份额的50%时，货币市场基金投资组合的平均剩余期限不得超过60天，平均剩余存续期不得超过120天；投资组合中现金、国债、中央银行票据、政策性金融债券以及5个交易日内到期的其他金融工具占基金资产净值的比例合计不得低于100%。"
        },
        {
            "title": "关于基金估值，以下表述正确的是（　　）。",
            "question": "A．对于投资者来说，持有期间基金净值的波动无关紧要，仅赎回的净值做到公允即可\nB．基金估值的第一责任主要为基金管理人，但基金合同另有约定的除外\nC．基金管理人可以将基金资产价格适当低估从而阻止巨额赎回\nD．基金交易活跃的证券估值时，一般采用最新的市场价格",
            "answer": "D",
            "explain": "基金估值主体在现有基金法律体系中是完备的，无论是《证券投资基金法》还是中国证监会关于基金合同的格式要求、基金估值业务规定等都明确规定，基金管理人是基金估值的第一责任主体，不存在其他情况。当基金只投资于交易活跃的证券时，对其资产进行估值较为容易。这种情况下，市场交易价格是可接受的，也是可信的，直接采用市场交易价格就可以对基金资产估值。"
        },
        {
            "title": "关于内在价值法，以下表述错误的是（　　）。",
            "question": "A．贴现模型的选择要与获得现金流相对应\nB．企业在支付投资部分现金流后优先为股权投资者提供股酬\nC．股利贴现模型、权益现金流贴现模型、企业贴现现金流模型都属于内在价值法\nD．内在价值法是按照未来现金流贴现对公司的内在价值进行评估",
            "answer": "B",
            "explain": "内在价值法又称绝对价值法或收益贴现模型，是按照未来现金流的贴现对公司的内在价值进行评估。包括：股利贴现模型（根据对股利增长率的假设，可分为零增长模型、不变增长模型、三阶段增长模型和多元增长模型）、自由现金流量贴现模型（企业自由现金流量（FCFF）贴现模型和股权自由现金流量（FCFE）贴现模型）、经济附加值模型等。企业首先向债权人支付负债利息，然后才能向公司股东进行红利分配。"
        },
        {
            "title": "关于现金流量表，以下表述正确的是（　　）。",
            "question": "A．现金流量表无法反映企业的长期资本筹集状况\nB．现金流量表可反映企业的资本结构\nC．现金流量表基本结构分为两部分：经营性现金流和投资性现金流\nD．现金流量表可评价企业未来产生现金净流量的能力",
            "answer": "D",
            "explain": "资产负债表反映公司资产负债的平衡关系，能够揭示出企业资产要素的信息、长期或短期偿还债务能力、资本结构是否合理、企业经营稳健与否或经营风险的大小以及股东权益结构状况等。现金流量表的基本结构分为三部分，即经营活动产生的现金流量（CFO）、投资活动产生的现金流量（CFI）和筹资（也称融资）活动产生的现金流量（CFF）。其中筹资活动产生的现金流量反映的是企业长期资本（股票和债券、贷款等）筹集资金状况。"
        },
        {
            "title": "下列与基金有关的费用，不能以基金财产中列支的是（　　）。",
            "question": "A．基金管理费\nB．基金托管费\nC．基金销售服务费\nD．基金申购费",
            "answer": "D",
            "explain": "基金销售过程中涉及两类费用：1.基金投资者承担的费用，主要包括申购费、赎回费及基金转换费，不参与基金的会计核算。2.基金管理过程中发生的费用，由基金资产承担，需要从基金财产中列支：（1）基金管理人的管理费；（2）基金托管人的托管费；（3）销售服务费；"
        }, {
            "title": "股票投资组合构建通常有自上而下和自下而上两种策略。关于自下而上策略，以下表述正确的是（　　）。",
            "question": "A．从行业配置入手\nB．从风格配置入手\nC．在实施中有固定模式\nD．关注个股表现",
            "answer": "D",
            "explain": "自上而下的投资策略从宏观经济形势及行业、板块特征入手，明确大类资产、国家、行业的配置，然后再挑选相应的股票作为投资标的，实现配置目标。自下而上则是依赖个股筛选的投资策略，注重的是各家公司的表现。"
        },
        {
            "title": "关于资本市场理论的问题期望假定，以下表述错误的是（　　）。",
            "question": "A．投资者认为所有资产的收益率服从同样概率分布\nB．在所有的投资者看来，同一个股票的标准差是一样的\nC．在所有的投资者看来，同一个股票的预期收益是一样的\nD．在所有的投资者看来，同一对股票的相关性是一样的",
            "answer": "A",
            "explain": "所有投资者的期望相同，即任何投资者认为同一个股票有相同的风险/收益分布。所有投资者都具有同样的信息，他们对各种资产的预期收益。"
        },
        {
            "title": "以下关于股票基金风险的说法，正确的是（　　）。",
            "question": "A．股票基金通过分散投资可以大大降低个股投资的系统性风险\nB．股票基金面临的投资风险可以分为系统性和非系统性风险\nC．股票基金的风险水平低于混合型基金\nD．不同类型股票基金所面临的系统性风险是相同的",
            "answer": "B",
            "explain": "股票基金是高风险的投资基金品种，相对于混合基金、债券基金与货币基金，股票基金的预期收益与风险皆为最高。股票基金面临较其他类型基金更高的投资风险，主要是非系统性和系统性风险。不同类型的股票基金所面临的系统性风险不同。例如，单一行业投资基金会存在行业风险。"
        },
        {
            "title": "关于我国证券交易所，以下表述错误的是（　　）。",
            "question": "A．证券交易所本身不进行证券买卖\nB．证券交易所是实行自律管理的法人\nC．证券交易所本身能决定证券交易价格\nD．证券交易所本身不持有证券",
            "answer": "C",
            "explain": "我国证券交易所是证券集中交易的场所，它组织和监督证券交易，并且实行自律管理，由国务院决定设立和解散。证券交易所的组织形式有会员制和公司制两种。我国上海证券交易所和深圳证券交易所都采用会员制，设会员大会、理事会和专门委员会。证券交易所作为进行证券交易的场所。"
        },
        {
            "title": "对于机构投资者买卖基金份额获得的差价收入，正确的税收处理方式为（　　）。",
            "question": "A．由基金管理公司代扣代缴企业所得税\nB．由机构投资者单独申报纳税\nC．并入企业应纳税所得额，征收企业所得税\nD．税法规定暂免征企业所得税",
            "answer": "C",
            "explain": "本题考查机构投资者的税收。"
        },
        {
            "title": "关于基金风险调整后的超额收益，以下表述错误的是（　　）。",
            "question": "A．在计算基金风险调整后的超额收益时，需要考虑所选择的时间区间\nB．获取正的风险调整后超额收益的能力反映基金投资管理的重要指标\nC．主动管理型基金不需要关注风险调整后的超额收益\nD．风险调整后的超额收益可以为正也可以为负",
            "answer": "C",
            "explain": "风险调整后的超额收益有正负之分，基金产生正的风险调整后超额收益的能力是反映基金投资管理能力的重要指标，正的风险调整后的超额收益也是主动管理型基金为投资者创造经济效益的终极体现。主动管理型基金同样需要关注风险调整后的超额收益。"
        },
        {
            "title": "关于证券登记结算机构，以下表述错误的是（　　）。",
            "question": "A．为证券市场提供安全高效的证券登记结算服务\nB．不以营利为目的\nC．证券登记结算机构不持有证券，所以不需要设立结算风险基金\nD．设立证券登记结算机构必须经国务院证券监督管理机构批准",
            "answer": "C",
            "explain": "《证券法》规定，证券登记结算机构是为证券交易提供集中登记、存管与结算服务，不以营利为目的的法人。设立证券登记结算机构必须经国务院证券监督管理机构批准，中国证券登记结算有限责任公司（简称中国结算公司）是我国的证券登记结算机构。"
        }, {
            "title": "跨境投资的投资研究风险主要注意下列哪些方面（　　）。",
            "questions": "I．国外企业债券多数没有担保机构<br>II．担保机构本身也存在较大的信用风险<br>III．在使用衍生证券进行套期保值时，需要准确计算衍生工具和基础证券之间的相关性，然后根据定价模型计算持有的数量，这一过程存在模型风险<br>IV．基金会计估值过程中经常会遇到数据来源不一致、证券交易不活跃、各国税收制度不一致等问题，这些问题都是潜在的模型风险",
            "question": "A．I、II、IV\nB．II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "货币市场工具风险较低，安全性高，主要参与交易的主体是（　　）。",
            "question": "A．个人投资者\nB．银行等机构投资者\nC．中小企业\nD．私募证券投资基金",
            "answer": "B",
            "explain": "货币市场工具有以下特点之一为：主要由机构投资者参与，个人投资者很少有机会参与买卖。"
        },
        {
            "title": "2015年度，某公司应收票据200亿元，存货30亿元，固定资产120亿元，无其他资产，则应计入非流动资产的金额为（　　）亿元。",
            "question": "A．320\nB．350\nC．150\nD．120",
            "answer": "D",
            "explain": "流动资产包括货币资金、应收账款、应收票据、存货及其他流动资产。非流动资产包括固定资产、无形资产、长期股权投资及其他非流动资产。因此本公司非流动资产只有固定资产120亿元。"
        },
        {
            "title": "关于基金经理在投资组合执行的过程中需要完成的工作，以下表述错误的是（　　）。",
            "question": "A．如果资产配置方案的变化是永久性的，那么基金经理会更新投资政策说明书\nB．投资经理构建投资组合、进行证券选择并执行投资决策\nC．基金经理会对投资组合进行优化\nD．基金经理会根据资本市场预期的变化对投资组合进行调整",
            "answer": "B",
            "explain": "在实际操作中，基金经理根据投资决策委员会的投资战略及研究部门的研究报告，结合对证券市场、上市公司、投资时机的分析，拟定所管理基金的具体投资计划，包括资产配置、行业配置、重仓个股投资方案。并不具体执行政策。"
        },
        {
            "title": "债券远期交易双方约定在某一日期，以约定的价格和数量买卖债券，从成交日至结算日期限可以由交易双方确定，但最长不得超过（　　）天。",
            "question": "A．90\nB．360\nC．180\nD．365",
            "answer": "D",
            "explain": "债券远期交易从成交日至结算日的期限（含成交日不含结算日）为2-365天。远期交易实行净价交易，全价结算。债券远期交易是指交易双方约定在未来某一日期，以约定的价格和数量买卖债券的行为。远期交易标的债券种类为已在全银行间债券市场进行现券交易的中央政府债券、中央银行债券、金融债券和资产支持证券等。根据中国人民银行的规定，证券市场参与者进行远期交易。"
        },
        {
            "title": "某基金的最新一期报告显示，其基金资产净值为10000万元，其中股票市值6500万元，债券市值2000万元，其余为现金类资产，则金，以下表述正确的是（　　）。",
            "question": "A．债券投资占基金资产净值的比例为35%\nB．股票投资占基金资产净值的比例为35%\nC．现金类资产占基金资产净值的比例为15%\nD．股票投资和债券投资占基金资产净值的比例总和为65%",
            "answer": "C",
            "explain": "债券投资占基金资产净值的比例为2000万/10000万=20%，股票投资占基金资产净值的比例为6500万/10000万=65%，现金类资产净值的比例为1-20%-65%=15%，股票投资和债券投资占基金资产净值的比例总和为20%+65%=85%。"
        }, {
            "title": "关于风险溢价与收益，以下表述错误的是（　　）。",
            "question": "A．投资者的期望收益率取决于其所期待的风险溢价和无风险溢价收益率的水平\nB．投资者承担的风险越高要求的风险溢价越多\nC．由于无法有效分散风险，投资者对承担的系统性风险不要求风险溢价\nD．在其他条件一致时，股票投资者对投资于风险更高的公司要求的期望收益率更高",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于公募基金利润分配，以下表述正确的是（　　）。",
            "questions": "I．货币市场基金可在基金合同中约定收益分配方式为红利再投资<br>II．当日申购的货币市场基金即日起享有基金的分配收益<br>III．现金分红是开放式基金分红采取的最普遍的形式<br>IV．开放式基金收益分配默认为采用分红再投资方式",
            "question": "A．I、III\nB．II、III\nC．I、II、IV\nD．I、II、III",
            "answer": "A",
            "explain": ""
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/jjjc-1.js